const permissions = {
  organizationCatalog: 'MB005',
  organizationAdd: 'MB006',
  organizationEdit: 'MB007',
  organizationDelete: 'MB008'
};

export default permissions;
